$(function () {
    const CLOSED_COUNT_KEY = 'new_year_banner_closed_count';
    const CLICKED_KEY = 'new_year_banner_clicked';
    const MAX_CLOSES = 1;
    const BANNER_SELECTOR = '[data-target="black-friday-banner"]';
    const CLOSE_SELECTOR = '[data-target="black-friday-banner-close"]';
    const PROMO_URL = 'https://ads.vk.com/promo/firstbonus?ref=Senler';

    const initBanner = () => {
        const banner = $(BANNER_SELECTOR);

        if (!banner.length) {
            return;
        }

        try {
            // Проверяем, был ли клик по баннеру
            if (localStorage.getItem(CLICKED_KEY) === '1') {
                banner.hide();
                return;
            }

            // Проверяем количество закрытий
            const closedCount = parseInt(localStorage.getItem(CLOSED_COUNT_KEY) || '0', 10);
            
            if (closedCount >= MAX_CLOSES) {
                banner.hide();
                return;
            }
        } catch (error) {
            // Если localStorage недоступен, показываем баннер
        }

        // Показываем баннер с анимацией
        setTimeout(() => {
            banner.addClass('black-friday-banner--visible');
        }, 100);

        // Обработчик клика на баннер (кроме кнопки закрытия)
        banner.on('click', (e) => {
            // Не переходим, если клик по кнопке закрытия
            if ($(e.target).closest(CLOSE_SELECTOR).length) {
                return;
            }
            
            try {
                localStorage.setItem(CLICKED_KEY, '1');
            } catch (error) {}

            window.carrotquest && window.carrotquest.track('Клик по баннеру VK Реклама');
            window.open(PROMO_URL, '_blank');
            banner.hide();
        });

        // Обработчик клика на кнопку закрытия
        const closeButton = banner.find(CLOSE_SELECTOR);
        if (closeButton.length) {
            closeButton.on('click', (e) => {
                e.stopPropagation();
                window.carrotquest && window.carrotquest.track('Закрыл баннер VK Реклама');
                closeBanner(banner);
            });
        }
    }

    const closeBanner = (banner) => {
        // Добавляем класс для анимации закрытия
        banner.removeClass('black-friday-banner--visible');
        banner.addClass('black-friday-banner--closing');

        // После завершения анимации скрываем баннер и увеличиваем счетчик закрытий
        setTimeout(() => {
            banner.hide();

            try {
                const closedCount = parseInt(localStorage.getItem(CLOSED_COUNT_KEY) || '0', 10);
                
                localStorage.setItem(CLOSED_COUNT_KEY, (closedCount + 1).toString());
            } catch (error) {}
        }, 300);
    }

    // initBanner();
});
